import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const TimelineMenu = (props) => {
    const [stateOpen, setOpen] = React.useState(false);
    const ref = React.useRef(null);
    React.useEffect(() => {
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target))
                setOpen(false);
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);
    return (_jsxs("div", { className: "dropdown ptl-menu", ref: ref, children: [_jsxs("button", { type: "button", className: "btn border bg-white d-inline-flex align-items-center gap-2 rounded-3 px-3 py-2", onClick: () => setOpen(open => !open), "aria-expanded": stateOpen, children: [_jsx("i", { className: props.icon }), _jsx("span", { className: "fw-medium", children: props.label }), _jsx("i", { className: `bi ${stateOpen ? 'bi-chevron-up' : 'bi-chevron-down'} small` })] }), stateOpen &&
                _jsx("div", { className: "dropdown-menu dropdown-menu-end show mt-2 ptl-menu-panel", onClick: () => setOpen(false), children: props.children })] }));
};
export default TimelineMenu;
